// extracted by mini-css-extract-plugin
module.exports = {"Content":"kanye-says_Content__3C4q0","Kanye":"kanye-says_Kanye__3cDMs"};